import React from 'react'
import config from '../config.json'
import checkForAttributeMapping from '../func/checkForAttributesMapping'


const FlyerSingleCaption = ({captionAttributeId, captionAttribute, translation}) => {
    const { captionLetter, captionName } = captionAttribute
    const attributesName = checkForAttributeMapping(captionName, translation)
    const logoClass = _.contains(config.attributesWithIcons, captionAttributeId) ? ' attribute-logo ': ''
    const doNotDisplayTitle = _.contains(config.attributesWithIcons, captionAttributeId) ? 'screen-reader-text ' : ''

    return (
        <div className='caption'>
            {captionLetter} = <span className={"dark-attribute" + logoClass} data-attribute={captionAttributeId}><span className={doNotDisplayTitle}>{attributesName}</span></span>
        </div>
    )
}

const FlyerCaptions = ({
    captionAttributes,
    translation
}) => (

    <div className='captions-wrapper'>
        {captionAttributes && Object.keys(captionAttributes).map((captionAttributeId, index) => <FlyerSingleCaption
            key={index}
            captionAttributeId={captionAttributeId}
            translation={translation}
            captionAttribute={captionAttributes[captionAttributeId]}
        />)}
    </div>
)

export default FlyerCaptions
